import {ChangeEvent} from "react";

import {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {phoneNumberFormatNational} from "@pg-mono/string-utils";

const PHONE_DIGIT_COUNT = 9;

export const getPhoneDigits = (value: string) => value.replace(/\D/g, "").slice(0, PHONE_DIGIT_COUNT);

export const handlePhoneInputChange =
    (code: IPhoneFieldValue["code"], onChange: (value: IPhoneFieldValue) => void) => (event: ChangeEvent<HTMLInputElement>) => {
        onChange({code, number: getPhoneDigits(event.currentTarget.value)});
    };

export const formatPhoneInputNumber = (code: IPhoneFieldValue["code"], number: string) => {
    const digits = getPhoneDigits(number);

    if (!digits) return "";

    return phoneNumberFormatNational(`${code} ${digits}`)
        .replace(new RegExp(`^\\+${code}\\s*`), "")
        .trim();
};
import {ChangeEvent} from "react";

import {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {phoneNumberFormatNational} from "@pg-mono/string-utils";

const PHONE_DIGIT_COUNT = 9;

export const getPhoneDigits = (value: string) => value.replace(/\D/g, "").slice(0, PHONE_DIGIT_COUNT);

export const handlePhoneInputChange =
    (code: IPhoneFieldValue["code"], onChange: (value: IPhoneFieldValue) => void) => (event: ChangeEvent<HTMLInputElement>) => {
        onChange({code, number: getPhoneDigits(event.currentTarget.value)});
    };

export const formatPhoneInputNumber = (code: IPhoneFieldValue["code"], number: string) => {
    const digits = getPhoneDigits(number);

    if (!digits) return "";

    return phoneNumberFormatNational(`${code} ${digits}`)
        .replace(new RegExp(`^\\+${code}\\s*`), "")
        .trim();
};
